import { Tab, TabProps, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.custom.grey5}`,
  borderRadius: '20px',
  minHeight: 'unset',
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    display: 'flex',
    width: 'none',
  },
}));

export const StyledTab = styled((props: TabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  flex: 1,
  width: '100%',
  maxWidth: 'none',
  textAlign: 'center',
  color: theme.palette.custom.black[100],
  borderRadius: '20px',
  opacity: 0.7,
  position: 'relative',
  overflow: 'hidden',
  zIndex: 1,
  fontWeight: 400,
  textTransform: 'none',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.primary.main,
    zIndex: -1,
    transform: 'scaleX(0)',
    transformOrigin: 'left',
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },

  '&.Mui-selected': {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    opacity: 1,
    fontWeight: 500,
    border: `1px solid ${theme.palette.custom.grey5}`,
  },
  '&:hover': {
    opacity: 0.9,
    backgroundColor: theme.palette.grey[300],
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));
